
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { EntityContainerModel } from '../../../../../../models/aggregates/erp/entity';
import { EntityCriteriaModelQuery, EntityQueryCriteriaClass } from '../../../criteria/entity-criteria.model';
import { ApiVisa, BaseApiTemplateService, Core2Config, BasicApiResponseModel } from '../../shared';
import { ApiResponseModel } from '../../shared/api-response.model';


@Injectable({
  providedIn: 'root'
})
export class SupplierService extends BaseApiTemplateService<EntityContainerModel> {

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/suppliers';
    this.endpoint_path =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/suppliers';
    this.endpoint_path_login_entity_url =  Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/suppliers/login-entity-ep';
    this.httpClient = http;
  }

  getSupplierByCriteria(visa: ApiVisa, criteria?: EntityQueryCriteriaClass):
    Observable<ApiResponseModel<EntityContainerModel>> {
      if (this.endpoint_path && visa.api_domain_url) {
        this.apiUrl = visa.api_domain_url + this.endpoint_path;
      }
    const buildEntityCriteriaCriteria = new EntityCriteriaModelQuery(criteria);
    console.log('query',buildEntityCriteriaCriteria.query);
    return this.httpClient.get<ApiResponseModel<EntityContainerModel>>(this.apiUrl + '/query?' +
      buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
  }

  public createTemp(dtoObject: any, visa: ApiVisa) {
    if (this.endpoint_path && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url;
    }
    return this.httpClient.post<BasicApiResponseModel<EntityContainerModel>>(
      this.apiUrl + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + 'entity/temp/suppliers/backoffice-ep',
      dtoObject,
      this.getHttpHeader(visa)
    );
  }

  getSupplierByCriteriaLoginEP(visa: ApiVisa, criteria?: EntityQueryCriteriaClass):
  Observable<ApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
  const buildEntityCriteriaCriteria = new EntityCriteriaModelQuery(criteria);
  console.log('query',buildEntityCriteriaCriteria.query);
  return this.httpClient.get<ApiResponseModel<EntityContainerModel>>(this.apiUrl + '/query?' +
    buildEntityCriteriaCriteria.query, this.getHttpHeader(visa));
}

  getByLogin(visa: ApiVisa): Observable<ApiResponseModel<EntityContainerModel>> {
    if (this.endpoint_path_login_entity_url && visa.api_domain_url) {
      this.apiUrl = visa.api_domain_url + this.endpoint_path_login_entity_url;
    }
    return this.httpClient.get<ApiResponseModel<EntityContainerModel>>(
      this.apiUrl,
      this.getHttpHeader(visa)
    );
  }

 
}
